import React, { Component } from "react";
import "./SeeInstruction.css";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import openPocketImg from "./images/open_pocket_img.png";
import chooseWristbandImg from "./images/choose_wristband_img.png";
import icon_arrow_right from "./images/icon_arrow_right.png";
import sample_qrcode from "./images/sample_qrcode.png";
import small_rectangle from "./images/small_rectangle.png";
import long_rectangle from "./images/long_rectangle.png";
import QRCode from "qrcode.react";
// Change language
import PropTypes from "prop-types";
import en from "./languages/en.json";
import th from "./languages/th.json";
// Translation Higher Order Component
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  translate,
} from "react-switch-lang";
import { CenterFocusStrong } from "@material-ui/icons";

// Do this two lines only when setting up the application
setTranslations({ en, th });
// setDefaultLanguage("en");

// If you want to remember selected language
setLanguageCookie();

const apiUrl =
  "https://centapi.andamandaphuket.com:8443/centaman.api/v3/giftcards?GiftcardNo=";
class SeeInstruction extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      current: 0,
    };
  }

  handleChange(event) {
    setLanguage(event.target.value);
    this.wristbandInput.focus();
  }

  componentDidMount() {
    // Start counting when the page is loaded
    this.timeoutHandle = setTimeout(() => {
      setLanguage("th");
      this.props.history.push("/");
    }, 10000);
    this.wristbandInput.focus();
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutHandle);
  }

  // getUserDetail = async (wristband) => {
  //   try {
  //     const response = await fetch(apiUrl + wristband, {
  //       method: "GET",
  //       headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
  //     });
  //     const result = await response.json();
  //     const userDetail = result[0];
  //     if (userDetail) {
  //       //3322780051
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //       this.props.history.push({
  //         pathname: "/page3",
  //         state: {
  //           giftcardNo: userDetail.GiftcardNo,
  //           giftcardExpiryDate: userDetail.GiftcardExpiryDate,
  //           cashOutBalance: userDetail.CashOutBalance,
  //           restrictedBalance: userDetail.RestrictedBalance,
  //           totalBalance: userDetail.TotalBalance,
  //         },
  //       });
  //     } else {
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //     }
  //   } catch (error) {
  //     this.wristbandInput.value = "";
  //     this.setState({ wristband: "" });
  //     this.props.history.push({
  //       pathname: "/page5",
  //       state: {},
  //     });
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  getUserDetail = (wristband) => {
    return new Promise((resolve, reject) => {
      fetch(apiUrl + parseInt(wristband), {
        method: "GET",
        headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
      })
        .then((response) => response.json())
        .then((result) => {
          const userDetail = result[0];

          if (userDetail) {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });

            const stateData = {
              giftcardNo: userDetail.GiftcardNo,
              giftcardExpiryDate: userDetail.GiftcardExpiryDate,
              cashOutBalance: userDetail.CashOutBalance,
              restrictedBalance: userDetail.RestrictedBalance,
              totalBalance: userDetail.TotalBalance,
            };

            this.props.history.push({
              pathname: "/page3",
              state: stateData,
            });

            resolve(stateData);
          } else {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });
            resolve(null); // Resolve with null to indicate no user detail
          }
        })
        .catch((error) => {
          this.wristbandInput.value = "";
          this.setState({ wristband: "" });

          this.props.history.push({
            pathname: "/page5",
            state: {
              wristband: wristband,
            },
          });

          reject(error); // Reject with the error
        })
        .finally(() => {
          // setLoading(false);
        });
    });
  };

  // handleWristbandKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     console.log("Enter press...", e.target.value);
  //     this.setState({ wristband: e.target.value });
  //     this.getUserDetail(e.target.value);
  //   }
  // };

  handleWristbandKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState({ wristband: e.target.value });
      this.getUserDetail(e.target.value)
        .then((stateData) => {
          if (stateData === null) {
            // Handle case where no user detail was found
            console.log("No user detail found");
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  render() {
    const { t } = this.props;
    let giftcardNo = new URLSearchParams(this.props.location.search).get(
      "giftcardNo"
    );

    if (giftcardNo) {
      giftcardNo = "Sample";
    }

    return (
      <div className="main" onClick={() => this.wristbandInput.focus()}>
        <input
          style={{
            opacity: "0",
            width: 0,
            height: 0,
          }}
          autoFocus={true}
          onKeyDown={this.handleWristbandKeyDown}
          ref={(inputEl) => (this.wristbandInput = inputEl)}
        />

        <div className="txtConnectToApp">
          {t("connectToApp")} <br />
        </div>
        <div className="openPocketContainer">
          <img
            className="instructionImg"
            src={openPocketImg}
            alt="Open Pocket"
          />
          <img
            className="smallRectangle"
            src={small_rectangle}
            alt="Small Rectangle"
          />
          <div className="txtOpenPocket">
            {t("openPocket")} <br />
          </div>
        </div>
        <div>
          <img
            className="iconArrowRight_1"
            src={icon_arrow_right}
            alt="arrow right"
          />
        </div>
        <div className="chooseWristbandContainer">
          <img
            className="instructionImg"
            src={chooseWristbandImg}
            alt="Choose Wristband ID"
          />
          <img
            className="longRectangle"
            src={long_rectangle}
            alt="Long Rectangle"
          />
          <div className="txtChooseWristband">
            {t("choose")} <br />
            {t("wristbandMenu")}
          </div>
        </div>
        <div>
          <img
            className="iconArrowRight_2"
            src={icon_arrow_right}
            alt="arrow right"
          />
        </div>
        <div className="scanToConnectContainer">
          <div>
            <div className="qrcodeImgContainer">
              <QRCode
                value={giftcardNo}
                size="170"
                renderAs="svg"
                level={"H"}
                fgColor="#333"
                bgColor="#fff"
                key={`level-H`}
                style={{
                  marginTop: "12px",
                  marginBottom: "12px",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
              />
            </div>
            {/* <img
              className="sampleQrcodeImg"
              src={sample_qrcode}
              alt="sample QRcode"
            /> */}
            <div className="txtScanToConnect">
              {t("scanQRcode")} <br />
              {t("forConnect")}
            </div>
          </div>
        </div>
        <div className="buttonContainer">
          <Link
            to={"/page1"}
            style={{
              textDecoration: "none",
            }}
          >
            <Button
              variant="contained"
              style={{
                background: "linear-gradient(90deg, #EC008C 0%, #FC6767 100%)",
                color: "#FFFFFF",
                borderRadius: "20px",
                width: "317px",
                height: "112px",
                fontSize: "36px",
                marginLeft: "530px",
              }}
              onClick={() => setLanguage("th")}
            >
              {t("done")}
            </Button>
          </Link>
        </div>
      </div>
    );
  }
}

SeeInstruction.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(SeeInstruction);
